/* tslint:disable */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/map';
import { DomStorageFallbackService } from './DomStorageFallback.service';
import { LoggingService } from './logging/logging.service';
import { LoggingConstants } from '../constants/logging-constant';
/* istanbul ignore next */
import { RemoteService } from './remote.service';
import { GenericService } from './generic.service';
import { AppUtility } from '../utils/utility';
import { IUrlOptions } from '../models/rest.caller.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CommonAppService {
  private cacheClearFlag = false;
  private windowOpen = false;
  private tabOpen = false;
  includeIVAJs = 'false';
  versn: any;
  browsr: any;
  browserdata: any;

  /* istanbul ignore next */
  constructor(
    private domStorageFB: DomStorageFallbackService,
    private loggingService: LoggingService,
    private appUtility: AppUtility,
    private genericService: GenericService,
    private remoteService: RemoteService
  ) { }

      /**
     * PCA-5381 : Clear Frond End Cache while landing on login/sso page
     * Clear all types of storage data for ./login and /sso page
     * This will clear all cached data from storage when user hits login page directly
     */
    public clearAllCachedStorage() {
      let lrJsonData: any = this.domStorageFB.getItem('lr_json_data');
      if (LoggingService.uConsole) {
          console.log('Base-app > clearAllCachedStorage : lrJsonData', lrJsonData);
      }
      if (lrJsonData) {
          try {
              lrJsonData = JSON.parse(lrJsonData);
              if (lrJsonData && !lrJsonData.userDetails) {

                  // Clear all localStorage items
                  this.domStorageFB.clear('localStorage');

                  // Clear all sessionStorage items
                  this.domStorageFB.clear('', true);

                  // Call clearIDBStores function to clear IndexedDB storage
                  // New Condition added for Log Off Functionality
                  const angularFirstSwitch = this.appUtility.isAfEnabled();
                  /* istanbul ignore next */
                  if (this.appUtility.isSwFeatureEnabled()) {
                      if (LoggingService.uConsole) {
                          console.log('CommonAppService| clearAllCachedStorage() : isSwFeatureEnabled()');
                      }
                      // UFD-1558, UFD-2146
                      // Enable cache clear from angular for srvice worker.
                      this.remoteService.clearAll_IDBStores_SW();
                  } else if (angularFirstSwitch && !this._window().Liferay) {
                      this.remoteService.clearAll_IDBStores();
                  } else {
                      if (this._window()) {
                          if (this._window().clearIDBStores && typeof this._window().clearIDBStores === 'function') {
                              this._window().clearIDBStores();
                              if (LoggingService.uConsole) {
                                  console.log('Base-app > clearAllCachedStorage : clearIDBstores');
                              }
                          }
                      }
                  }
                  this.cacheClearFlag = true;
              }
          } catch (error) {
              /* istanbul ignore next */
              if (LoggingService.uConsole) {
                  console.log('Error in clear All Cache function ', error);
              }
          }
      } else {
          /* istanbul ignore next */
          if (LoggingService.uConsole) {
              console.log('Error in clear All Cache function. LR Json Data not found.');
          }
      }
  }


 /**
  * Methos for fetching and storing clientId in session storage.
  */
  /* istanbul ignore next */
  public fetchStoreClientId() {
      const aRHJsonbject = JSON.parse(this.domStorageFB.getItem('alightRequestHeader'));
      const attributeName = 'clientId';
      if (aRHJsonbject) {
          if (aRHJsonbject[attributeName]) {
              try {
                  this.domStorageFB.setItem('clientIdValue', aRHJsonbject[attributeName].trim());
              } catch (error) {
                  if (LoggingService.uConsole) {
                      console.log('Error occurred while setting clientId attrbute in sessionStorage=>fetchStoreClientDtl() ', error);
                  }
              }
          }
      }

  }


public setParamsValuesFromInitConfigCall(res: any) {
      const initJson = res;
      this.domStorageFB.setItem('AE_LOCK', true, '', );
      try {
          Object.keys(initJson).forEach(key => {
              const initConfigData = initJson[key];
              Object.keys(initConfigData).forEach(keyJson => {

                  /* istanbul ignore next */
                  if (keyJson === 'expr') {
                      const exprData = initConfigData[keyJson];

                      let tempObj = {
                          'ADOPT_UPOINT_RELEASE_53': false,
                          'IS_ECS_ADMIN': false,
                          'IS_INTRO_OVERLAY_ENABLED': false,
                      };

                      if (exprData) {
                          tempObj = {
                              'ADOPT_UPOINT_RELEASE_53': exprData.ADOPT_UPOINT_RELEASE_53,
                              'IS_ECS_ADMIN': exprData.IS_ECS_ADMIN,
                              'IS_INTRO_OVERLAY_ENABLED': exprData.IS_INTRO_OVERLAY_ENABLED,
                          };

                          this.domStorageFB.setItem('IntroOverlayConfig', JSON.stringify(tempObj), 'localStorage');
                      }
                  }

                  /* istanbul ignore next */
                  if (keyJson === 'properties') {
                      const jsonData = initConfigData[keyJson];
                      Object.keys(jsonData).forEach(jsonKey => {
                          if (jsonKey === 'AE_LOCK') {
                              this.domStorageFB.setItem(jsonKey, jsonData[jsonKey], '', );
                              return;
                          }
                      });
                  }
                  
                  /* istanbul ignore next */
                  if (keyJson === 'userActivityTrackingIds') {
                    const jsonData = initConfigData[keyJson];
                    this.domStorageFB.setItem(keyJson, JSON.stringify(jsonData), '');
                   }
              });
          });
      } catch (error) {
          if (LoggingService.uConsole) {
              console.log('Exception in getting AE_LOCK value form initconfig json with exception message =' + error);
          }
      }
  }

/**
   * Init loader config
   */
  getLoaderConfig() {
      const endPointUrl = 'channel/widgetconfigurations/channel/widgetConfigurations/loaderTextConfig';

      try {
          if (endPointUrl) {
              return this.remoteService.request('get', {
                  restOfUrl: '',
                  endPoint: endPointUrl, isSecure: true, contentType: 'application/json'
              });
          }
      } catch (error) {
          // tslint:disable-next-line:max-line-length
          this.loggingService._error('Exception occurred while getLoaderConfig in UpointBase app ' + error, endPointUrl, LoggingConstants.ERROR);
      }
  }

  /**
   * Track Link click Events for Angular First and route to appropriate route
   * Track click event and clicked element. If it is Anchor tag and contains link to Angular First page
   * then redirect page to Angular First page else do nothing
   * @param event
   */
  /* istanbul ignore next */
  public trackEventsAF(event) {

    const uConsole = this.domStorageFB.getItem('uConsole');
      /* istanbul ignore next */
      if (this.domStorageFB.getItem('includeIVAJs') !== null && this.domStorageFB.getItem('includeIVAJs') !== 'undefined') {
          this.includeIVAJs = this.domStorageFB.getItem('includeIVAJs', '', true);
      }

    if (uConsole) {
        console.group('START: trackEventsAF() - Track Link click Events for Angular First and route to appropriate route');
    }

      try {
          if (event.target && event.target.nodeName) {
              // const isIE = this.appUtility.getBrowser();
              const element = (event.target as HTMLElement);
              const findEle = this.appUtility.findClosest(event.target, 'BY_TAG', 'a');
              const findBtnEle = this.appUtility.findClosest(event.target, 'BY_CLASS', 'al-video-button');
                if (findBtnEle) {
                    if (findBtnEle.nodeName.toLowerCase() === 'button') {
                        let findBtnUrl = window.location.href;
                        this.routeToAngularPage(findBtnUrl, event);
                        window.location.reload(false);
                        return true;
                    }
                }
                if (findEle && findEle.nodeName) {
                    if (findEle.nodeName.toLowerCase() === 'a') {

                        // if not secondary window then increment
                        /* if (!findEle.classList.contains('ah-secondaryWindow') || !findEle.classList.contains('al-secondaryWindow')) {
                            if (isIE.indexOf('ie') !== -1) {
                                if (this.domStorageFB.getItem('ieMemoryClearCounter', 'localStorage')) {
                                    let ieMemoryClearCounter = this.domStorageFB.getItem('ieMemoryClearCounter', 'localStorage');
                                    this.domStorageFB.setItem('ieMemoryClearCounter', (Number(ieMemoryClearCounter) + 1), 'localStorage')
                                }
                            }
                        } */

                  if (element.hasAttribute('routerlink')) {
                      // If it is an Angular Router then Do nothing
                      if (uConsole) {
                          console.warn('trackEventsAF() - this link is already converted to routerLink. No further action needed.');
                      }
                  } else {
                      let getOnclickAttr;
                      let onClick = true;
                      getOnclickAttr = findEle.getAttribute('onclick');
                      let targetAttribute = findEle.getAttribute('target');
                      if (getOnclickAttr != undefined && getOnclickAttr != null && (getOnclickAttr.indexOf('cloudcmsdocuments') !== -1)) {
                        console.log('onclick attribute for download document');
                        this.downloadCloudDocument(getOnclickAttr, onClick, event);
                        return true;
                    }
                    if (findEle.href != undefined && findEle.href != null && (findEle.href.indexOf('cloudcmsdocuments') !== -1)) {
                        console.log('href attribute for download document');
                        onClick = false;
                        let secondaryClass = findEle.getAttribute('class');
                        if (secondaryClass) {
                            if (secondaryClass === 'ah-secondaryWindow') {
                                this.windowOpen = true;
                            }
                            if (secondaryClass === 'ah-secondaryTab') {
                                this.tabOpen = true;
                            }
                        }
                        console.log('download document call-href');
                        this.downloadCloudDocument(findEle.href, onClick, event);
                        return true;
                    }
                      if (getOnclickAttr != undefined && getOnclickAttr != null && (getOnclickAttr.indexOf('processUrlForIntranet') !== -1)) {
                          return true;
                      }
                      if (getOnclickAttr != undefined && getOnclickAttr != null && (getOnclickAttr.indexOf('window.open') !== -1)) {
                          return true;
                      }
                      /* if (uConsole) {
                          console.log('event.target.href =====', findEle.href, findEle.href.indexOf('#/web'));
                      } */
                      const handleIvaInterval = setInterval(() => {
                          // tslint:disable-next-line:max-line-length
                          if (this.includeIVAJs === 'true' && !this.appUtility.isLiferay()) {
                              clearInterval(handleIvaInterval);
                              const IVA_PRTL_REDIRECT = this.genericService.getQueryParamValue('IVA_PRTL_REDIRECT', '');
                              const advAssetGrp = this.genericService.getQueryParamValue('advAssetGrp', '');
                              const linkId = this.genericService.getQueryParamValue('linkId', '');

                              if (IVA_PRTL_REDIRECT !== null && (advAssetGrp !== null || linkId !== null)) {
                                  this.handleIVAUrlLink(window.location.href);
                                  return true;
                              }
                          }
                      }, 100);
                      if (targetAttribute != undefined && targetAttribute != null && targetAttribute === '_blank') {
                          return true;
                      }
                      try {
                          if (getOnclickAttr != undefined && getOnclickAttr != null) {
                              if (getOnclickAttr.indexOf('setTimeout') !== -1) {
                                  const setTimeoutString = getOnclickAttr.substr(getOnclickAttr.indexOf('setTimeout'), getOnclickAttr.length - 1);
                                  if (setTimeoutString.indexOf('document.location.href') !== -1) {
                                      return;
                                  }
                              }
                          }
                      } catch (error) {
                          if (LoggingService.uConsole) {
                              console.log('error in settimeout substring');
                          }
                      }
                      if (findEle.href != undefined && findEle.href != null && findEle.href !== "") {
                          event.preventDefault();
                          let hrefChangeFlag = this.routeToAngularPage(findEle.href, event);
                          if (!hrefChangeFlag) {
                              window.location.href = findEle.href;
                          }
                      }
                  }
              }
            }
          } else {

          }
      } catch (error) {
          if (uConsole) {
              console.error('trackEventsAF() : Error in getting details of clicked element.', error);
          }
      }

      if (uConsole) {
          console.log('END: trackEventsAF() - Track Link click Events for Angular First and route to appropriate route');
          console.groupEnd();
      }

}

/* istanbul ignore next */
public handleIVAUrlLink(href) {
    if (href !== null && href !== undefined) {
      if (this.genericService.getQueryParamValue('IVA_PRTL_REDIRECT', '') !== undefined && this.genericService.getQueryParamValue('IVA_PRTL_REDIRECT', '')) {
        if (this.domStorageFB.getItem('alightSecureSessionToken', '', true) ||
          this.domStorageFB.getItem('alightPersonSessionToken', '', true)) {
            
          if (this.genericService.getQueryParamValue('advAssetGrp', '') !== undefined || this.genericService.getQueryParamValue('linkId', '') !== undefined) {
              // window.location.reload();
                this.includeIVAJs = this.domStorageFB.getItem('includeIVAJs');

            if (this.includeIVAJs) {
              this.handleIVAUrl();
            }
          }
          
        }
      }
    }
  }

  /* istanbul ignore next */
  public handleIVAUrl() {
    let pageConverted = false;
    const portal = this.genericService.getQueryParamValue('IVA_PRTL_REDIRECT', '');
    const link = this.genericService.getQueryParamValue('linkId', '');
    const advAsstGrp = this.genericService.getQueryParamValue('advAssetGrp', '');
    if (portal && advAsstGrp && link) {
      // send to home page
      this.routeToHomePage();
    } else if (portal && advAsstGrp) {
      this.getConfigSetData(pageConverted, 'assetGroup', advAsstGrp);
    } else if (portal && link) {
      this.getConfigSetData(pageConverted, 'link', link);
    } else if (portal && !advAsstGrp && !link) {
      // send to home page
      this.routeToHomePage();
    }
  }

  /* istanbul ignore next */
  getConfigSetData(pageConverted, config: string, configKey: string) {
    const linkUce = this.genericService.getQueryParamValue('uce', '');
    let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
    let lineage = JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.toString();
    let preAuthFlag = false;
    if (!this.domStorageFB.getItem('alightSecureSessionToken', '', true) || !this.domStorageFB.getItem('alightPersonSessionToken', '', true)) {
      pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
      lineage = JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.toString();
      preAuthFlag = true;
    }
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: pageGroupUrl,
      isSecure: true,
      contentType: 'application/json'
    };
    let requestBody;
    if (config === 'link') {
        let link = [];
        link.push({ 'linkName': configKey, 'requestType': 'link' });
        if (linkUce) {
            requestBody = {
                'lineage': lineage,
                'locale': 'en_US',
                'operation': 'configset',
                'linkKeys': link,
                'uce': true
            };
        } else {
            requestBody = {
                'lineage': lineage,
                'locale': 'en_US',
                'operation': 'configset',
                'linkKeys': link
            };
        }
    }
    else if (config === 'assetGroup') {
        let assetgroup = [];
        assetgroup.push({ 'assetGroup': configKey, 'resolveAll': 'true' });
        if (linkUce) {
            requestBody = {
                'lineage': lineage,
                'locale': 'en_US',
                'operation': 'configset',
                'assetKeys': assetgroup,
                'uce': true
            };
        } else {
            requestBody = {
                'lineage': lineage,
                'locale': 'en_US',
                'operation': 'configset',
                'assetKeys': assetgroup
            };
        }
    }
    this.remoteService.request('post', options, requestBody).subscribe((respData) => {
        if (respData !== undefined && respData._body !== undefined) {
            let resp = JSON.parse(respData._body)[0];
            let tag;
            let linkId;
            if (config === 'link') {
                if (linkUce) {
                    tag = resp.link_uce[configKey].tag;
                }
                else {
                    tag = resp.link[configKey].tag;
                }
                let href = this.routeIVALink(tag);
                if (this.genericService.ifPageIsConverted(configKey)) {
                    this.routeToAngularPage(href, event);
                }
                else {
                    window.location.href = href;
                }
                // this.routeIVALink(pageConverted, tag);
            }
            if (config === 'assetGroup') {
                if (linkUce) {
                    linkId = Object.keys(resp.asset_uce[configKey]);
                }
                else {
                    linkId = Object.keys(resp.asset[configKey]);
                }
                let tag = resp.asset[configKey][linkId[0]].assetValue;
                let href = this.routeIVALink(tag);
                if (this.genericService.ifPageIsConverted(linkId[0])) {
                    this.routeToAngularPage(href, event);
                }
                else {
                    window.location.href = href;
                }
            }
        }
    },
      (error) => {
        if (LoggingService.uConsole) {
          console.log('error while fetching iva flag ' + Error);
        }
      });
  }

  /* istanbul ignore next */
  routeToHomePage(){
    let url = window.location.href;
      if (url.indexOf('?') !== -1) {
        const hrefquery = url.split('?');
        url = hrefquery[0]+'?linkId=GLBL_NAV_HOME';
      }
      if(this.genericService.ifPageIsConverted('GLBL_NAV_HOME')){
        this.routeToAngularPage(url,event);
      }
      else{
        window.location.href = url;
      }
  }

  /* istanbul ignore next */
  routeIVALink(tag: string) {
    let hrefValue;
    try {
      if (tag.trim().length > 0) {
        let str = tag;
        hrefValue = str.substring(str.indexOf("href=\"") + 6, str.indexOf("\"", str.indexOf("href=\"") + 6));
        if (LoggingService.uConsole) {
          console.log("href value is " + hrefValue);
        }
      }
    } catch (error) {
      if (LoggingService.uConsole) {
        console.log('Error in routeIVALink() function == ', error);
      }
    }
    return hrefValue;
  }

/* istanbul ignore next */
public downloadCloudDocument(attribute, onClick, event) {
    console.log('download document starts');
    const searchStr = 'cloudcmsdocuments';
    let reqUrl = '';
    let serviceEndPoint = '';
    const filePathStr = '?filepath=';
    let getDocument = '';
    let documentName = '';
    let reqEndPoint = '';
    let appendFlag = '';
    event.preventDefault();
    try{
    if (onClick) {
        reqUrl = String(attribute);
    }
    else {
        // reqUrl = decodeURIComponent(attribute);
        reqUrl = attribute;
    }
    getDocument = reqUrl.split(searchStr).pop().split('?')[0].substr(1);
    documentName = getDocument;
    if (documentName && !this.appUtility.isLiferay()) {

        if (this.appUtility.isPreAuth()) {
            serviceEndPoint = 'channel/content/documentManagement/document/public';
        } else {
            serviceEndPoint = 'channel/content/documentManagement/document';
        }

        reqEndPoint = filePathStr + documentName;

        let options: IUrlOptions;

        options = {
            restOfUrl: reqEndPoint,
            endPoint: serviceEndPoint,
            isSecure: true,
            contentType: 'application/json'
        };

        return this.remoteService.request('get', options, '', '', '', false, 'blob').subscribe((res) => {
            /* istanbul ignore next */
            if (res && res.size > 0) {
                const blob: Blob = new Blob([res], { type: res.type });
                if (this.windowOpen || this.tabOpen) {
                    if (window.navigator) {
                        const UA = (window).navigator.userAgent;
                        if((UA.indexOf('MSIE') > -1 || UA.indexOf('Trident') > -1 || UA.indexOf('Edge') > -1) && window.navigator.msSaveOrOpenBlob){
                            window.navigator.msSaveOrOpenBlob(blob);
                            return;
                        }
                    }
                    var fileURL = window.URL.createObjectURL(blob);
                    if(this.tabOpen){
                        window.open(fileURL,'_blank');
                    }else{
                        window.open(fileURL, '', 'width=1000,height=600,titlebar=true,resizable=true,scrollbars=true,fullscreen=false');
                    }
                } else {
                    // const fileName = getDocument.split('/').pop();
                    // appendFlag = 'cloudCmsFlag';
                    let encodedDocument = getDocument.split('/').pop();
                    let fileName = decodeURIComponent(encodedDocument);
                    const UA = (window).navigator.userAgent;
                    if((UA.match('Firefox'))) {
                        appendFlag = 'cloudCmsFlagAs';
                    }
                else {
                    appendFlag = 'cloudCmsFlag';
                    
                }
                this.appUtility.downloadFile(blob, fileName, appendFlag);
                }
            }
            this.windowOpen = false;
                this.tabOpen = false;
        }, (error) => {
            /* istanbul ignore next */
            this.windowOpen = false;
            this.tabOpen = false;
            if (LoggingService.uConsole) {
                console.log('error in document download link ..', error);
            }
        });
    } else {
		if (LoggingService.uConsole) {
            console.log('CMS: method:downloadCloudDocument Liferay Content Found');
        }
	}
    } catch (error) {
        if (LoggingService.uConsole) {
        console.log('error processing download request');
        }
    }
}
    /* istanbul ignore next */
    public routeToAngularPage(pageUrl, event) {
        const uconsole = this.domStorageFB.getItem('uConsole');
        if (uconsole) {
            console.group(' pageUrl ' + pageUrl);
        }
        const routeDef = JSON.parse(this.domStorageFB.getItem('routeDefinition'));
        let isHrefChanged = false;
        isHrefChanged = this.routeByPageName(routeDef, pageUrl);
        return isHrefChanged;
    }
/* istanbul ignore next */
    public routeByPageName(assetRoutes, pageUrl) {
        const uConsole = this.domStorageFB.getItem('uConsole');
        let angularFirstURL = this.genericService.getAngularFirstUrl();
        let browser = this.appUtility.getBrowser();
        console.log('Browser name is : ' + browser);
        if ( (browser.indexOf('ie') !== -1) || (browser.indexOf('edge') !== -1) ) {
            let randomSalt = Math.floor(Math.random() * 10000);
            angularFirstURL = angularFirstURL + '?' + + randomSalt;
            console.log('page url is : ' + pageUrl);
            console.log('angular first url is : ' + angularFirstURL);
        }
        const orgName = this.genericService.getOrgName();
        let pageArray = null;
        let pageName, pgName, queryString = null, isHrefChanged = false, isRouteMatch = false, urlStr;
        if (pageUrl && pageUrl.indexOf('#/web') > -1) {
            urlStr = pageUrl.split('#/web/')[1];
            if (urlStr.indexOf('?')) {
                pageName = urlStr.split('?')[0];
                pageName = pageName.substring(pageName.indexOf('/') + 1, pageName.length);
                pageArray = pageName.split('/');
                if (pageArray.length === 1) {
                    pgName = pageArray[0];
                    pgName = pgName.replace(/-/g, '');
                } else {
                    pgName = pageArray[pageArray.length - 1];
                    pgName = pgName.replace(/-/g, '');
                }
                queryString = urlStr.split('?')[1];
            }
        } else {
            if (pageUrl && pageUrl.indexOf('/web/') > -1) {
                urlStr = pageUrl.split('/web/')[1];
                if (urlStr.indexOf('?')) {
                    pageName = urlStr.split('?')[0];
                    pageName = pageName.substring(pageName.indexOf('/') + 1, pageName.length);
                    pageArray = pageName.split('/');
                    if (pageArray.length === 1) {
                        pgName = pageArray[0];
                        pgName = pgName.replace(/-/g, '');
                    } else {
                        pgName = pageArray[pageArray.length - 1];
                        pgName = pgName.replace(/-/g, '');
                    }
                    queryString = urlStr.split('?')[1];
                }
            }
        }
        if (assetRoutes && pgName) {
            for (let key in assetRoutes) {
                if (key === pgName) {
                    isRouteMatch = true;
                    let routeObj = assetRoutes[key];
                    if (uConsole) {
                        console.log('trackEventsAF() - Key Index ===> ', 0, ' | KEY ===> ', key);
                    }
                    if (routeObj['flavours']) {
                        const flavors = routeObj['flavours'];
                        let updatedUrl = this.checkFlavorExpValue(flavors, pageName, queryString, false);
                        if (updatedUrl) {
                            isHrefChanged = true;
                            if (uConsole) {
                                console.log('trackEventsAF() - flavor matched ==> updatedUrl', updatedUrl);
                            }
                            console.log('routed url is : from if : updatedUrl : ' + updatedUrl);
                            window.location.href = updatedUrl;
                        } else {
                            console.log('routed url is : from if : pageUrl : ' + pageUrl);
                            window.location.href = pageUrl;
                        }
                    } else {
                        // when pagename matched but exp get false for all flavours, also route to angular url
                        if (isRouteMatch && !isHrefChanged) {
                            isHrefChanged = true;
                            if (queryString === null) {
                                // tslint:disable-next-line:max-line-length
                                let url = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?flavorCheck=true';
                                console.log('routed url is : from if : url : ' + url);
                                window.location.href = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?flavorCheck=true';
                            } else {
                                // tslint:disable-next-line:max-line-length
                                let url = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?' + queryString + '&flavorCheck=true';
                                console.log('routed url is : from else : url : ' + url);
                                window.location.href = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?' + queryString + '&flavorCheck=true';
                            }
                        }
                    }
                }
            }
            // when pagename did not match, route to liferay url
            /* if (!isHrefChanged) {
                window.location.href = pageUrl;
            } */
        } else {
            // linkId not found in "routeDefinition" Object
            // so this seems "Liferay" link. Do nothing
            if (uConsole) {
                // tslint:disable-next-line:max-line-length
                // console.warn(`trackEventsAF() - "linkId" not found in "routeDefinition" Object for key = ${key}, so this seems "Liferay" link. No further action needed.`);
            }
        }
        return isHrefChanged;
    }

    /* istanbul ignore next */
    public checkFlavorExpValue(flavors, pageName, queryString, isRouterLink) {
        let angularConvertedLink = null;
        let angularFirstURL = this.genericService.getAngularFirstUrl();
        let browser = this.appUtility.getBrowser();
        if ( (browser.indexOf('ie') !== -1) || (browser.indexOf('edge') !== -1) ) {
            let randomSalt = Math.floor(Math.random() * 10000);
            angularFirstURL = angularFirstURL + '?' + + randomSalt;
            console.log('angular first url is : inside checkFlavorExpValue() : ' + angularFirstURL);
        }
        const orgName = this.genericService.getOrgName();
        const flavorArray = new Array<any>();
        for (const flavour in flavors) {
            if (flavour) {
                const flavourObj = flavors[flavour];
                // if (flavourObj['flavourName'] !== 'DEFAULT') {
                flavorArray.push(flavourObj);
                // }
            }
        }
        for (const flavourObj in flavorArray) {
            if (flavourObj) {
                const routeObj = flavorArray[flavourObj];
                const flavourName = routeObj['flavourName'];
                const routeExpr = routeObj['expr'];
                if (routeExpr) {
                    const customExprValue = this.domStorageFB.getItem('expValueMap');
                    if (customExprValue && customExprValue !== 'undefined') {
                        const customExprValueMap = JSON.parse(customExprValue);
                        const exprValue = customExprValueMap[routeExpr];
                        if (exprValue === true) {
                            const redirectComponentPage = flavourName;
                            if (redirectComponentPage && redirectComponentPage.trim().length > 0) {
                                if (isRouterLink) {
                                    // tslint:disable-next-line:max-line-length
                                    angularConvertedLink = 'web/' + orgName + '/' + redirectComponentPage;
                                } else {
                                    // tslint:disable-next-line:max-line-length
                                    angularConvertedLink = angularFirstURL + '#/web/' + orgName + '/' + redirectComponentPage + '?' + queryString + '&flavorCheck=true';
                                }
                            } else {
                                if (isRouterLink) {
                                    // tslint:disable-next-line:max-line-length
                                    angularConvertedLink = 'web/' + orgName + '/' + pageName;
                                } else {
                                    if (queryString === null) {
                                        // tslint:disable-next-line:max-line-length
                                        angularConvertedLink = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?flavorCheck=true';
                                    } else {
                                        // tslint:disable-next-line:max-line-length
                                        angularConvertedLink = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?' + queryString + '&flavorCheck=true';
                                    }
                                }
                            }
                            return angularConvertedLink;
                        }
                    }
                }
            }
        }
        return angularConvertedLink;
    }
  /**
   * Extract URL parameter value from URL querystring
   * @param name Name of the query string parameter in URL
   * @param url A complete URL
   */
  /* istanbul ignore next */
  public getUrlParameter(name, url) {
    if (!url) {
        url = window.location.href;
    }
    url = decodeURIComponent(url);

    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

    /**
     * Function to check if page is converted to Angular First, if converted return TRUE else return FALSE
     * If "linkID" is available in "routeDefinition" object, then AF page is available
     * @param uri URL value in string format
     */
    /* istanbul ignore next */
    public isAFPageConverted(uri: string) {
        let isAFUrl = false;

        try {
            if (uri) {
                const routeDef = JSON.parse(this.domStorageFB.getItem('routeDefinition'));
                const linkId = this.getUrlParameter('linkId', uri);

                if (routeDef) {
                    for (const key in routeDef) {
                        if (routeDef.hasOwnProperty(key)) {
                            if (routeDef[key] && routeDef[key].linkID) {
                                if (routeDef[key].linkID === linkId) {
                                    // Angular page : Page is converted to Angular First
                                    isAFUrl = true;
                                }
                            }
                        }
                    }
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('isAFPageConverted :', error);
            }
        }

        return isAFUrl;
    }

    /* istanbul ignore next */
    public ahBrowserDet() {
        var str, browser, browserName, version, ieComp = false;
        var uAgent = navigator.userAgent || '';
   
       // CHECK BROWSERS FOR CERTIFIED VERSIONS
       if (uAgent.match(/edge/i)) {
           str = String(uAgent.match(/edge\/[0-9.]*/i)).split('/');
           browser = str[0];
           version = str[1];
           browserName = browser + '&reg;' + ' ' + version;
           
       } else if (uAgent.match(/edg/i)) {
           str = String(uAgent.match(/edg\/[0-9.]*/i)).split('/');
           browser = str[0];
           version = str[1];
           browserName = browser + '&reg;' + ' ' + version;
           
       } else if (uAgent.match(/chrome/i)) {
           str = String(uAgent.match(/chrome\/[0-9.]*/i)).split('/');
           browser = str[0];
           version = str[1];
           browserName = browser + '&trade;' + ' ' + version;
   
       } else if (uAgent.match(/firefox/i)) {
           str = String(uAgent.match(/firefox\/[0-9.]*/i)).split('/');
           browser = str[0];
           version = str[1];
           browserName = browser + '&reg;' + ' ' + version;
   
       } else if (uAgent.match(/opera/i)) {
           str = String(uAgent.match(/Version\/[0-9.]*/i)).split('/');
           browser = 'opera';
           version = str[1];
           browserName = 'Opera&reg;' + ' ' + version;
   
       } else if (uAgent.match(/Safari/i)) {
           str = String(uAgent.match(/Version\/[0-9.]*/i)).split('/');
           browser = 'safari';
           version = str[1];
           browserName = 'Safari&reg;' + ' ' + version;
       }
   
       // CHECK IE FOR CERTIFIED VERSION
       if (uAgent.indexOf('MSIE') > -1 || uAgent.indexOf('Trident') > -1) {
   
           if (uAgent.indexOf('MSIE 7.0') > -1) {
               ieComp = true;
           }
           browser = 'ie';
           version = this.get_browser_vers();
           browserName = 'Internet Explorer&reg;' + ' ' + version;
       } 
        this.browsr = browser;
        this.versn = version;
        return browser + ' ' + version;
   }

   /* PGCV-3755 - Blocked Browser routing */
   /* istanbul ignore next */
   public isBrowserblocked(browserdata){
        let cur_browserval = this.ahBrowserDet();
        this.browsr = cur_browserval.split(" ")[0];
        this.versn = cur_browserval.split(" ")[1];
        for (let key in browserdata) {
            if (key.toLowerCase() == this.browsr.toLowerCase()) {
                if (parseFloat(this.versn) <= parseFloat(browserdata[key].assetValue)) {
                    if (LoggingService.uConsole) {
                        console.log("Browser Version is Blocked", this.versn+this.browsr);
                    }
                    const orgName = this.genericService.getOrgName();
                    const upointUrl = this.genericService.getUpointNextUrl() + '/web/' + orgName + '/certified-browser-alert-help';
                    window.location.href = upointUrl;
                }
                else{
                    if (LoggingService.uConsole) {
                        console.log("Browser Version Allowed", this.versn+this.browsr);
                    }
                }
            }
        }      
    }

    /* istanbul ignore next */
    public get_browser_vers() {
        let ua = navigator.userAgent || '', 
        tem, 
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            // return 'IE '+(tem[1]||'');
            return (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\bOPR\/(\d+)/);
            if (tem != null) {/*return 'Opera '+tem[1];*/return tem[1]; }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    
        if (M[0] === 'MSIE' && M[1] === '7') {
            if (ua.indexOf('Trident/7.0') > -1) {
                M[1] = '11';
            } else if (ua.indexOf('Trident/6.0') > -1) {
                M[1] = '10';
            } else if (ua.indexOf('Trident/5.0') > -1) {
                M[1] = '9';
            } else if (ua.indexOf('Trident/4.0') > -1) {
                M[1] = '8';
            }
        }
        return M[1];
    }

    // Get global window object of browser
public _window(): any {
  // return the global native browser window object
  return window;
}
}
 /* tslint:enable */
